module.exports = __webpack_public_path__ + "media/images/header27-3c390b63400251818439704b30087910.png";